import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import Spinner from '../common/Spinner';

const PlanRoute = ({ children, requiredPlan }) => {
  const auth = getAuth();
  const db = getFirestore();
  const user = auth.currentUser;

  const [isAuthorized, setIsAuthorized] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const checkPlan = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          // Verifica se o usuário tem o plano necessário
          if (
            userData.plano === requiredPlan ||
            (requiredPlan === 'Premium' && userData.plano === 'Empresarial') ||
            (requiredPlan === 'Empresarial' && userData.plano === 'Empresarial')
          ) {
            setIsAuthorized(true);
          }
        }
      }
      setLoading(false);
    };

    checkPlan();
  }, [user, db, requiredPlan]);

  if (loading) {
    return <Spinner />;
  }

  return isAuthorized ? children : <Navigate to="/perfil-de-usuario" />;
};

PlanRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPlan: PropTypes.string.isRequired,
};

export default PlanRoute;
